export default __webpack_public_path__ + "static/char-s-61-zh-Hans-350855c8a4753d9910579d49b7af4440.webp";